import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Platform } from "@ionic/angular";
import { Navigator } from "src/app/components/menu/navigator";
import { ConfigService } from "../config/config.service";
import { EventsService } from "../event/event.service";
import { UniqueIDService } from "../unique-id/unique-id.service";
import { App } from "@capacitor/app";

@Injectable({
  providedIn: "root",
})

export class MobileToolsService {
  public shouldSelectEnvironment: boolean = false;
  public shouldUpdate: boolean = false;
  public shouldRestrictPlayStore: boolean = false;

  constructor(
    private uniqueIDProvider: UniqueIDService,
    private http: HttpClient,
    private platform: Platform,
    private eventsService: EventsService,
    public config: ConfigService,
    public navigator: Navigator,
  ) { }

  async checkEnvironmentSelector() {
    if (this.platform.is("capacitor")) {
      let deviceId = await this.uniqueIDProvider.getSelectorID();
      try {
        let optionParams = new HttpParams();
        optionParams.set("device_id", deviceId);
        console.log("check_device device_id:", deviceId);

        const checkdevice_url = `https://devpala1.palainteractive.com/check_device.php?device_id=${deviceId}&ts=${Date.now()}`;
        console.log(`check_device call: ${checkdevice_url}`);

        const data: any = await this.http.get(checkdevice_url).toPromise()
        console.log("check_device response:", JSON.stringify(data));

        let response = data;
        if (response.result == 1) {
          console.log("DEBUG MODE ALLOWED");
          this.shouldSelectEnvironment = true;
        } else {
          // v this.eventsService.publish("event:affiliation:initialize");
          this.eventsService.publish("event:config:final"); // this event fires *after* environment-selector phase is done
        }

      }
      catch (err) {
        console.log("...something wrong when checking device id: ", err);
        // v this.eventsService.publish("event:affiliation:initialize");
        this.eventsService.publish("event:config:final"); // this event fires *after* environment-selector phase is done -- very useful!
      };
    } else {

      console.log("UpdateCheckComplete")
      // v  this.eventsService.publish("event:affiliation:initialize");
      setTimeout(() => {
        this.eventsService.publish("event:config:final"); // this event fires *after* environment-selector phase is done 
      }, 1000);
    }
  }

  async checkRestrictedPlayStore() {
    if (this.platform.is("android")) {
        this.http.get( this.config.getEnv().webservices_url + '/configuration/get-is-allowed', {}).subscribe( (response:any) => {
            if( !response.payload || !(response.payload.geo.eligib === 'true')) {
                this.shouldRestrictPlayStore = true;
                this.navigator.navigateTo("AppRestrictedComponent", {}, {});
            }
        });
    }
  }

  async checkForUpdate() {
    return new Promise(async (resolve, reject) => {
      console.log("MobileToolsService checkForUpdate")

      console.log(`MobileToolsService APP_UPDATE_VERSION_ANDROID      ${this.config.getConfig().APP_UPDATE_VERSION_ANDROID}`)
      // console.log(`MobileToolsService APP_UPDATE_MESSAGE_ANDROID      ${this.config.getConfig().APP_UPDATE_MESSAGE_ANDROID}`)
      // console.log(`MobileToolsService APP_UPDATE_BUTTON_LABEL_ANDROID ${this.config.getConfig().APP_UPDATE_BUTTON_LABEL_ANDROID}`)
      // console.log(`MobileToolsService APP_UPDATE_URL_ANDROID          ${this.config.getConfig().APP_UPDATE_URL_ANDROID}`)

      console.log(`MobileToolsService APP_UPDATE_VERSION_IOS          ${this.config.getConfig().APP_UPDATE_VERSION_IOS}`)
      // console.log(`MobileToolsService APP_UPDATE_MESSAGE_IOS          ${this.config.getConfig().APP_UPDATE_MESSAGE_IOS}`)
      // console.log(`MobileToolsService APP_UPDATE_BUTTON_LABEL_IOS     ${this.config.getConfig().APP_UPDATE_BUTTON_LABEL_IOS}`)
      // console.log(`MobileToolsService APP_UPDATE_URL_IOS              ${this.config.getConfig().APP_UPDATE_URL_IOS}`)

      const androidInfo = {
        version: this.config.getConfig().APP_UPDATE_VERSION_ANDROID || null,
        url: this.config.getConfig().APP_UPDATE_URL_ANDROID || null,
        message: this.config.getConfig().APP_UPDATE_MESSAGE_ANDROID || null,
        buttonLabel: this.config.getConfig().APP_UPDATE_BUTTON_LABEL_ANDROID || null,
      };

      const iosInfo = {
        version: this.config.getConfig().APP_UPDATE_VERSION_IOS || null,
        url: this.config.getConfig().APP_UPDATE_URL_IOS || null,
        message: this.config.getConfig().APP_UPDATE_MESSAGE_IOS || null,
        buttonLabel: this.config.getConfig().APP_UPDATE_BUTTON_LABEL_IOS || null,
      };

      const info = this.platform.is("capacitor") ? await App.getInfo() : { "id": "com.boydgaming.stardustcasino", "version": "1.0.99", "build": "1", "name": "Startdust" }
      console.log(`MobileToolsService App.getInfo() ${JSON.stringify(info)}`, info)

      const v: string = !!info.version ? info.version : "1.0.0";

      let version, url, message, btnLabel;
      if (iosInfo.version != null && androidInfo.version != null)
        version = this.platform.is("ios") ? iosInfo.version : androidInfo.version;
      else {
        // version = data.version;
      }

      if (androidInfo.url != null && iosInfo.url != null) {
        url = this.platform.is("ios") ? iosInfo.url : androidInfo.url;
      }
      if (androidInfo.message != null && iosInfo.message != null) {
        message = this.platform.is("ios") ? iosInfo.message : androidInfo.message;
      }
      if (androidInfo.buttonLabel != null && iosInfo.buttonLabel != null) {
        btnLabel = this.platform.is("ios") ? iosInfo.buttonLabel : androidInfo.buttonLabel;
      }

      let currentParts = v.split(".");
      let checkingParts = version.split(".");

      if (parseInt(currentParts[0]) < parseInt(checkingParts[0])) {
        console.log("new MAJOR version");
        this.shouldUpdate = true;
      } else if (
        parseInt(currentParts[0]) == parseInt(checkingParts[0]) &&
        parseInt(currentParts[1]) < parseInt(checkingParts[1])
      ) {
        console.log("new MINOR version");
        this.shouldUpdate = true;
      } else if (
        parseInt(currentParts[0]) == parseInt(checkingParts[0]) &&
        parseInt(currentParts[1]) == parseInt(checkingParts[1]) &&
        parseInt(currentParts[2]) < parseInt(checkingParts[2])
      ) {
        console.log("new BUILD version");
        this.shouldUpdate = true;
      }

      if (!this.shouldUpdate) {
        console.log("UP TO DATE!");
      } else {
        console.log("NEEDS UPDATE!");

        this.navigator.navigateTo("AppUpdateComponent", { customModalClass: 'crown-modal mobile-update', animated: false, backdropDismiss: false }, {
          appversion: version,
          appURL: url,
          appMessage: message,
          btnLabel: btnLabel,
        });
      }
      resolve(this.shouldUpdate)
    });
  }

}
